import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, NO_ERRORS_SCHEMA, OnDestroy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { BehaviorSubject, Subject, combineLatest, takeUntil } from 'rxjs';

@Component({
    selector: 'app-formly-field-array',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
        <div [id]="field.key" [class]="'form-group schema-form-array ' + props['htmlClass'] || ''">

            <div [class]="props['fieldHtmlClass']" *ngFor="let field of field.fieldGroup; let i = index">

                <div class="row section__heading">
                    <div class="col-sm-6 ">
                        <h3>{{props['itemTitle']}} {{i+1}}</h3>
                    </div>
                    <div class="col-sm-6">
                        <button (click)="remove(i)" style="position: relative; z-index: 20;" type="button"
                            class="close pull-right">
                            <span aria-hidden="true" [class]="'cross'+i+1">&times;</span><span class="sr-only">Close</span>
                        </button>
                    </div>
                </div>

                <formly-group [model]="model[i]" [field]="field" [options]="options" [form]="formControl"></formly-group>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="clearfix" style="padding: 15px;" >
                            <button class="btn pull-right" [ngClass]="props['style']['add'] || 'btn-default'" type="button"
                                (click)="add()">{{props['add'] || 'Add'}}
                            </button>
                        </div>

                        <ng-container *ngIf="showHelpBlock | async as showHelpBlock">
                            <div class="help-block" *ngIf="showHelpBlock || props['description']">
                                <p style="color: #b90000;">{{props['validationMessage']}}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
  `
})
export class ArrayFieldTypeComponent extends FieldArrayType implements AfterViewInit, OnDestroy {
    private destroy$ = new Subject<void>();
    showHelpBlock = new BehaviorSubject(false);

    ngAfterViewInit() {
        const observables = combineLatest([
            this.form.valueChanges,
            this.form.statusChanges,
        ]);

        observables.pipe(takeUntil(this.destroy$)).subscribe(() => {
            if (this.form.hasError(this.field!.key!.toString())) {
                this.showHelpBlock.next(true);
            }
            else {
                this.showHelpBlock.next(false);
            }
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
